import type { Change } from 'diff';

export const getChangeStatus = (
  change: Change,
): 'added' | 'removed' | 'unchanged' => {
  if (change.added) {
    return 'added';
  }
  if (change.removed) {
    return 'removed';
  }
  return 'unchanged';
};
